import { render, staticRenderFns } from "./friendLoading.vue?vue&type=template&id=05486964&"
import script from "./friendLoading.vue?vue&type=script&lang=js&"
export * from "./friendLoading.vue?vue&type=script&lang=js&"
import style0 from "./friendLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports